import { action, computed, makeObservable, observable, reaction } from 'mobx'
import { TextareaStore } from 'store/textareaStore'
import { VoiceStore } from 'store/voiceStore/voiceStore'
import { RinglessStore } from 'store/ringlessStore/ringlessStore'
import mediaStore from 'store/mediaStore'
import contactStore from 'store/contacts/contactStore'
import { ContentType } from 'src/generated/graphql'
import { IPreviewMessage } from 'components/Preview/types'
import uiStore from 'store/uiStore'
import numbersStore from 'store/settings/numbers/numbersStore'
import { TrackConversionStore } from 'widgets/TrackConversion/store/trackConversionStore'

export class CreateStore {
  textareaStore: TextareaStore
  mediaStore: typeof mediaStore
  contactStore: typeof contactStore
  voiceStore: VoiceStore
  ringlessStore: RinglessStore
  trackConversionStore: TrackConversionStore
  constructor({
    createBtnText,
    placeholder,
  }: {
    createBtnText: string
    placeholder?: string
  }) {
    this.textareaStore = new TextareaStore()
    this.mediaStore = mediaStore
    this.contactStore = contactStore
    this.voiceStore = new VoiceStore()
    this.ringlessStore = new RinglessStore()
    this.trackConversionStore = new TrackConversionStore()
    this.createBtnText = createBtnText
    this.placeholder = placeholder || ''
    makeObservable(this, {
      type: observable,
      isHaveChanges: observable,
      activeTab: computed,
      name: observable,
      previewMessagePhone: observable,
      smsPhone: observable,
      voicePhone: observable,
      uuidCode: observable,
      company: observable,
      activeModalTab: observable,
      createBtnText: observable,
      openTest: observable,
      sendTimeString: observable,
      trackConversionStore: observable,
      isAdvanced: observable,

      smsPhoneFull: computed,
      previewMessage: computed,

      setContentType: action.bound,
      setName: action.bound,
      setActiveModalTab: action.bound,
      setSMSPhone: action.bound,
      setVoicePhone: action.bound,
      setCompany: action.bound,
      setOpenTest: action.bound,
    })

    reaction(
      () => this.isHaveChanges,
      (isHaveChanges) => {
        uiStore.setBeforeUnload(isHaveChanges)
      }
    )
    reaction(
      () => this.phonePull,
      (phone) => {
        this.textareaStore.setTestMode(phone?.type === 'TEST_TOLL_FREE')
      }
    )
  }
  placeholder = ''
  type: ContentType = ContentType.Sms
  name = ''
  previewMessagePhone = ''
  smsPhone = ''
  voicePhone = ''
  uuidCode = ''
  company = ''
  activeModalTab = 0
  createBtnText = ''
  openTest = false
  isHaveChanges = false

  sendTimeString = 'Immediately'

  get previewMessage(): IPreviewMessage {
    return {
      type: this.type,
      textareaStore: this.textareaStore,
      voiceStore: this.voiceStore,
      ringlessStore: this.ringlessStore,
      phone: this.phonePull?.friendlyName || '',
    }
  }

  get smsPhoneFull() {
    return numbersStore.numbersMapByFriendly.get(this.smsPhone)
  }
  get voicePhoneFull() {
    return numbersStore.numbersMapByFriendly.get(this.voicePhone)
  }
  get phonePull() {
    if (this.type === ContentType.Sms) {
      return this.smsPhoneFull
    }
    return this.voicePhoneFull
  }

  get activeTab() {
    if (this.type === ContentType.Voice) {
      return 1
    }
    if (this.type === ContentType.Ringless) {
      return 2
    }
    return 0
  }

  setName = (name: string) => {
    this.name = name
  }

  setContentType = (type: ContentType) => {
    this.type = type
  }

  setActiveModalTab(val: number) {
    this.activeModalTab = val
  }

  setSMSPhone(phone: string) {
    if (
      numbersStore.toolFreeNumbers.find(
        (number) => number.friendlyName === phone
      )
    ) {
      this.smsPhone = phone
      this.voicePhone = phone
    } else {
      if (this.activeTab === 0) {
        this.smsPhone = phone
      } else {
        this.voicePhone = phone
      }
    }
  }
  setVoicePhone(phone: string) {
    this.voicePhone = phone
  }

  setCompany(company: string) {
    this.company = company
    this.textareaStore.setAdditionalText(company)
  }
  setOpenTest(state: boolean) {
    this.openTest = state
  }

  isAdvanced = false
  setAdvanced = (value: boolean) => {
    this.isAdvanced = value
  }
  toggleAdvanced = () => {
    this.isAdvanced = !this.isAdvanced
  }

  checkIsShowShortLinkRequiredModal = () => {
    let isRequired = false
    if (this.type === 'SMS') {
      if (this.trackConversionStore.conversionInput?.id) {
        if (!this.textareaStore.hasShortLinks) {
          isRequired = true
        }
      }
    }
    return isRequired
  }
}
